import React from 'react'
import CodeAssist from "../../CodeAssist/CodeAssistWrapper.js";
const AuditorCodeAssist = () => {
  return (
    <>
      <CodeAssist />
    </>
  )
}

export default AuditorCodeAssist
